import ButtonForPopup from './ButtonForPopup/main'

function ButtonForPopupApp({ config }) {
  return <ButtonForPopup config={config} />
}

export default ButtonForPopupApp
